export enum MaintenanceStrategyTriggerType {
  Schedule = "schedule",
  Usage = "usage",
  Anomaly = "anomaly",
}
